import styled from "@emotion/styled";
import { MDSText } from "@/mds/components/text";

export const StyledDialogChip = styled.span<{ $inline?: boolean }>`
  display: ${({ $inline }) => ($inline ? "inline-flex" : "flex")};
  align-items: center;
  gap: ${({ theme }) => theme.spacing["1"]};
  min-width: 0;

  ${({ $inline }) =>
    !$inline &&
    `
      flex: 1 1 auto;
      overflow: hidden;
    `}
`;

export const StyledIconContainer = styled.span<{ $inline?: boolean }>`
  display: ${({ $inline }) => ($inline ? "inline-flex" : "flex")};
  flex-shrink: 0;
`;

export const StyledLabelText = styled(MDSText)<{ $inline?: boolean }>`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
